import { render, staticRenderFns } from "./Dziecko.vue?vue&type=template&id=cca428b8&scoped=true&"
import script from "./Dziecko.vue?vue&type=script&lang=js&"
export * from "./Dziecko.vue?vue&type=script&lang=js&"
import style0 from "./Dziecko.vue?vue&type=style&index=0&id=cca428b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca428b8",
  null
  
)

export default component.exports